<template>
  <div class="map-containerr">
    <iframe
      v-if="mapUrl"
      class="map-embed"
      :src="mapUrl"
      title="附近台灣聯通停車場"
      loading="lazy"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "ParkingMaplet",

  data() {
    return {
      mapUrl: "",
    };
  },

  mounted() {
    // 先顯示預設位置，避免手機定位權限尚未回應時地圖空白。
    this.setMapUrl(25.033, 121.5654);
    this.getCurrentLocation();
  },

  methods: {
    setMapUrl(lat, lng) {
      const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
      this.mapUrl =
        `https://www.google.com/maps/embed/v1/search` +
        `?key=${apiKey}` +
        `&q=${encodeURIComponent("台灣聯通停車場")}` +
        `&center=${lat},${lng}` +
        `&zoom=14`;
    },

    getCurrentLocation() {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          this.setMapUrl(lat, lng);
        },
        () => {
          // 定位失敗時保留已顯示的台北預設位置。
        },
        {
          enableHighAccuracy: false,
          timeout: 8000,
          maximumAge: 600000,
        }
      );
    },
  },
};
</script>

<style scoped>
.map-containerr {
  width: 100%;
  height: 100%;
}

.map-embed {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
